/**
 * Tax-information tab of the Location detail (DNKADM-0080) — the second tab at
 * `/locations/:locationId/tax`.
 *
 * Hosts the **unchanged** per-location {@link TaxRatesEditor} (DNKADM-0051), moved
 * from its former inline spot in `LocationDetail` into this tab body. The location is
 * fixed by the route param; behavior is otherwise unchanged. Gated by the detail's
 * `RequireAdmin` route — no re-gate here.
 */
import { useParams } from 'react-router-dom';
import { TaxRatesEditor } from './TaxRatesEditor';

export function LocationTaxTab() {
  const { locationId = '' } = useParams<{ locationId: string }>();
  return <TaxRatesEditor locationId={locationId} />;
}
